import React from 'react';
import { AppModule } from '../../core';
import { DashboardHeaderless, DashboardLayout } from '../../core/layouts';

const adminModule: AppModule = {
  routes: [
    {
      path: '/admin/users/:userId/scan-results/:scanResultId',
      permissions: ['Admin'],
      layout: DashboardHeaderless,
      name: 'Scan Result Page',
      page: React.lazy(() => import('../scan-results/pages/scan-result')),
      hidden: true,
      routes: [
        {
          path: '/admin/users/:userId/scan-results/:scanResultId/details',
          page: React.lazy(() => import('../scan-results/pages/scan-result-details')),
          name: 'Scan Result Details',
        },
      ],
    },
    {
      path: '/admin',
      layout: DashboardLayout,
      page: React.lazy(() => import('./pages/admin')),
      permissions: ['Admin'],
      routes: [
        {
          path: '/admin/groups',
          name: 'Groups',
          page: React.lazy(() => import('./pages/groups')),
        },
        {
          path: '/admin/users',
          name: 'Users',
          page: React.lazy(() => import('./pages/users')),
          exact: true,
        },
        {
          path: '/admin/users/:id',
          name: 'Details',
          exact: true,
          page: React.lazy(() => import('./pages/user-details')),
          hidden: true,
        },
      ],
    },
  ],
};

export default adminModule;
